import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyPolicyOverview from "./sections/PrivacyPolicyOverview";
import DataCollectionUsage from "./sections/DataCollectionUsage";
import HowWeUseYourData from "./sections/HowWeUseYourData";
import UserRightsContactInformation from "./sections/UserRightsContactInformation";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <PrivacyPolicyOverview />
      <DataCollectionUsage />
      <HowWeUseYourData />
      <UserRightsContactInformation />
      <Footer />
    </div>;
}